import React, { useRef, useState, useEffect } from 'react';
import axios from 'axios';
import { useParams } from 'react-router';
import { Helmet } from 'react-helmet';
import useApiUrl from '../../framework/hooks/useApiUrlHook';
import Navigation from '../../components/Navigation';
import EorikSlider from '../../components/slider/EorikSlider';
import Footer from '../../components/Footer';
import HotspotDetailTemplate1 from './detail/HotspotDetailTemplate1';

export default function HotspotDetail() {
    const apiUrl = useApiUrl();
    const [data, setData] = useState(false);
    const { location, hotspot } = useParams();

    const getData = () => {
        axios
            .post(`${apiUrl}/hotspots/detail`, { location, hotspot })
            .then((response) => {
                setData(response.data);
            })
            .catch((err) => {
                console.log(err);
            });
    };

    useEffect(() => {
        if (apiUrl != null) getData();
    }, [apiUrl]);

    return (
        <>
            <Helmet>
                <title>
                    {`${data.hotspot?.titel} - ${process.env.MIX_REACT_APP_APP_NAME} ${data.hotspot?.location}`}
                </title>
            </Helmet>
            <Navigation />
            {/* Start Ecorik Slider Area */}
            <div className="banner-wrapper">
                <section className="eorik-slider-area">
                    <EorikSlider
                        items={data?.slideshow}
                        imageFolder="bezienswaardigheden_header"
                        imageTyoe="header"
                        text={data.hotspot?.titel}
                    />
                </section>
                <div className="white-shape">
                    <img src="/assets/images/banner/banner-shape.png" alt="Image" />
                </div>
            </div>
            {/* End Ecorik Slider Area */}

            <HotspotDetailTemplate1 data={data} />

            <Footer />
        </>
    );
}
